import * as actionTypes from '../constants/actionType';
import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
//import {getMIntroById} from "../reducers/index";


//Action Creators
export const loadMIntroStart = (id) => {
  return {
    type: actionTypes.MINTRO_LOAD_START,
    id
  };
};
export const loadMIntroFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MINTRO_LOAD_FAIL,
    id,
    error
  };
};
export const loadMIntroSuccess = (data) => {
  return {
    type: actionTypes.MINTRO_LOAD_SUCCESS,
    data
  };
};

export const initMIntro = id => dispatch => {
  dispatch(loadMIntroStart(id));

  apiActions.loadEndpoint(apiValues.nref.mIntro.endpoint, id).then(result => {
    let normalized = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mIntro.fieldsUsed);

    dispatch(loadMIntroSuccess(normalized));
  });
};


